import styled from "styled-components";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import NavigationMobile from "./NavigationMobile/NavigationMobile";
import NavigationDesktop from "./NavigationDesktop";
import NavbarDesktopButton from "./NavbarDesktopButton";
import {
  desktopMarginVal,
  desktopMarginsCutoff,
  mainNavBarZ,
  mobileMarginVal,
  navbarHeight,
} from "../../styleConstants";

// just the top header with the hamburger menu
const NavBarWrapper = styled.div`
  position: sticky;
  top: 0;
  background: white;

  display: flex;
  height: ${navbarHeight}px;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid #e5e5e5;

  // needs to be more than sign in box
  z-index: ${mainNavBarZ};

  margin-left: ${mobileMarginVal}px;
  margin-right: ${mobileMarginVal}px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    margin-left: ${desktopMarginVal}px;
    margin-right: ${desktopMarginVal}px;
  }
`;

const AccountLogo = styled.div`
  background: black;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 18px;

  text-align: center;
  line-height: 36px;

  cursor: pointer;
`;

const Navbar = () => {
  const screenWidth = useSelector((state) => state.screenWidth.value);
  let isMobile = screenWidth < 732;

  const userInfo = useSelector((state) => state.userInfo.value);
  let accountLogo = null;
  // if we have a signed in user, make the account logo the first char of email or phone
  if (userInfo?.email) {
    accountLogo = userInfo.email.charAt(0);
  } else if (userInfo?.phone) {
    // we want the first number after the +1
    accountLogo = userInfo.phone.charAt(2);
  }

  return (
    <>
      <NavBarWrapper>
        {isMobile ? <NavigationMobile /> : <NavigationDesktop />}
        {accountLogo && (
          <Link to="/account" style={{ textDecoration: "none" }}>
            <AccountLogo>{accountLogo}</AccountLogo>
          </Link>
        )}
        {!accountLogo && !isMobile && (
          <Link to="/signin" style={{ textDecoration: "none" }}>
            <NavbarDesktopButton text={"SIGN IN"} onClick={() => {}} />
          </Link>
        )}
      </NavBarWrapper>
    </>
  );
};

export default Navbar;
